import {useFormState} from 'react-final-form';
import {useSelector} from 'react-redux';

function useWordsCalculator(pageName, spaceName) {
    const formState = useFormState();
    const options = useSelector(state => state.orderOptions.data);

    const values = formState && formState.values ? formState.values : {};
    const pages = Number(values[pageName]) || 0;
    const spacingValue = values[spaceName];
    let space = null;

    if (options && options.spacing && Array.isArray(options.spacing)) {
        for (let i = 0; i < options.spacing.length; i++) {
            if (String(options.spacing[i].value) === String(spacingValue)) {
                space = options.spacing[i];
                break;
            }
        }
    }

    const wordsPerPage = space && space.words ? space.words : 0;
    return pages * wordsPerPage;
}

export default useWordsCalculator;
